import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const DRIVER_LOCATIONS_ACTION_TYPES = generateApiActionTypes('DRIVER_LOCATIONS')

export const getDriverLocations = (
  uuid,
  limit = 5,
  includeRogue = true,
  includeManualPings = true
) => {
  const id = `${uuid}/driver_locations`
  const params = { limit, includeRogue, includeManualPings }
  const requestData = {
    endpoint: ENDPOINTS.users,
    params,
    id,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(DRIVER_LOCATIONS_ACTION_TYPES),
    },
  }
}

export const getParentDriverLocations = (
  id,
  limit = 5,
  includeRogue = true,
  includeManualPings = true
) => {
  const group = 'driver_locations'
  const params = { limit, includeRogue, includeManualPings }
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    params,
    id,
    group,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(DRIVER_LOCATIONS_ACTION_TYPES),
    },
  }
}
